import { useSWRConfig } from "swr";

const useSwrCache = () => {
    const { cache, mutate } = useSWRConfig();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ch = cache as Map<string, any>; // SWR uses a map, but the type doesnt include the clear or has method

    /** Invalidate all cache keys */
    const invalidateAllCache = () => {
        const keys = cache.keys();
        const keyArray = [...keys]; // Array.from(keys)

        keyArray.forEach((key) => {
            mutate(key);
        });
    };

    /**
     * Invalidate all cache that contains the string provided e.g. 'action' or 'site'
     * @param contain - the string to search for in the cache keys
     */
    const invalidateCacheKeyContaining = (contain: string) => {
        const keys = cache.keys();
        const keyArray = [...keys]; // Array.from(keys)

        keyArray.forEach((key) => {
            if (key.includes(contain)) {
                mutate(key);
            }
        });
    };

    /**
     * Invalidate a single swr cache
     * @param key the key to invalidate
     */
    const invalidateCacheKey = (key: string) => {
        if (ch.has(key)) {
            mutate(key);
        }
    };

    /**
     * Clear out all cache except for the key provided
     * @param key the key to keep in the cache
     */
    const invalidateAllCacheOtherThan = (keyToKeep: string) => {
        const keys = cache.keys();
        const keyArray = [...keys]; // Array.from(keys)

        keyArray.forEach((key) => {
            if (key !== keyToKeep) {
                mutate(key);
            }
        });
    };

    /**
     * Clear out all cache except for the keys containing the sting provided
     * @param key the key to keep in the cache
     */
    const invalidateAllCacheOtherThanContaining = (contain: string) => {
        const keys = cache.keys();
        const keyArray = [...keys]; // Array.from(keys)

        keyArray.forEach((key) => {
            if (!key.includes(contain)) {
                mutate(key);
            }
        });
    };

    return {
        globalMutate: mutate,
        invalidateAllCache,
        invalidateCacheKeyContaining,
        invalidateCacheKey,
        invalidateAllCacheOtherThan,
        invalidateAllCacheOtherThanContaining,
    };
};

export default useSwrCache;
